import { PropTypes } from "base/react-libs";
import { ThreeDotActionsMenu } from "@evertrue/et-components";
import TaskRowDetailsContactCard from "apps/journeys/components/journeys-page/task-table/task-row/task-row-details-contact-card";
import CompleteTaskToggle from "apps/tasks/components/complete-task-toggle";
import { useState } from "react";
import Api from "entities/helpers/api";
import { formatGivingDate, givingTimeAgo } from "apps/journeys/utils/helpers";

const RecommendedActionRow = ({ viewed, contact, giving, id }) => {
  const [rowViewed, setRowViewed] = useState(viewed);

  const handleCompletionClick = () => {
    setRowViewed(async (prev) => {
      if (!prev) {
        await Api.JOURNEYS.RECOMMENDED_ACTIONS_VIEW.put({
          urlArgs: { id: id },
        });
      }
      return !prev;
    });
  };

  const formattedDate = formatGivingDate(giving.last_gift_date);
  const timeAgo = givingTimeAgo(giving.last_gift_date);

  if (rowViewed) {
    return <></>;
  }

  return (
    <div className="recommended-action-row--container">
      <div className="recommended-action-row--contact">
        <CompleteTaskToggle task={{ completed_at: rowViewed }} size="small" onClick={handleCompletionClick} />
        <TaskRowDetailsContactCard contact={contact} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <div>
          <span className="giving-amount">${giving.last_gift_amount}</span> | {giving.last_gift_label}
        </div>
        <div className="giving-date">
          Gift Date: {formattedDate} {timeAgo}
        </div>
      </div>
      <div>
        <div>5</div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <ThreeDotActionsMenu options={[]} iconSize={1} />
      </div>
    </div>
  );
};

RecommendedActionRow.propTypes = {
  viewed: PropTypes.bool,
  contact: PropTypes.object,
  giving: PropTypes.object,
  id: PropTypes.number,
};

export default RecommendedActionRow;
